import { InsuranceMonitorConfiguration } from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";

import { RequirementDefinitionStandardIdentityVerificationFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_IDENTITY_VERIFICATION_FORM: RequirementDefinitionTemplateForm<
  InsuranceMonitorConfiguration,
  RequirementDefinitionStandardIdentityVerificationFormValues,
  null
> = {
  getDefaultSettingsValues: template => ({}),
  getEditSettingsValues(template, requirementDefinition) {
    return {};
  },
  mapDataSourceResponseToRequirementCreateRequest: null,
  mapFormDataToDataSourceCreateRequest: null,
  partialForm: null,
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({})
};
